import React from 'react';
import * as PropTypes from 'prop-types';
import CreatableSelect from 'react-select/creatable';

export class CustomCreatableSelect extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            hasBeenTouched: false,
        };
    }

    render() {
        const {isValid, invalidMessage, validBeforeTouched} = this.props;
        const {hasBeenTouched} = this.state;

        const showInvalid = !isValid && (hasBeenTouched || !validBeforeTouched);

        const customStyles = {
            control: (base, state) => ({
                ...base,
                // eslint-disable-next-line no-nested-ternary
                'borderColor': state.isFocused ? '#ddd' : showInvalid ? 'red' : '#ddd',
                '&:hover': {
                    // eslint-disable-next-line no-nested-ternary
                    borderColor: state.isFocused ? '#ddd' : showInvalid ? 'red' : '#ddd',
                },
            }),
        };

        const customSelectProps = {
            ...this.props,
            menuPosition: 'fixed'
        }

        return (
            <React.Fragment>
                <CreatableSelect styles={customStyles} {...customSelectProps} onBlur={() => this.setState({hasBeenTouched: true})} />
                {(showInvalid && invalidMessage)
                    && <div className="invalid-feedback-select">{invalidMessage}</div>
                }
            </React.Fragment>
        );
    }
}

CustomCreatableSelect.defaultProps = {
    invalidMessage: '',
    validBeforeTouched: true,
    isValid: true,
};

CustomCreatableSelect.propTypes = {
    isValid: PropTypes.bool,
    invalidMessage: PropTypes.string,
    validBeforeTouched: PropTypes.bool,
};

export default CustomCreatableSelect;
